/**
 * Configuration for the minimal data required to create a listing.
 */
export class AddModel {

  public map: {
    show: boolean;
    roles: string[];
  } = {
    show: false,
    roles: []
  };

  constructor(model?: Partial<AddModel>) {
    if (model) {
      if (model.map) {
        this.map = { ...model.map };
      }
    }
  }
}
